import { toast } from 'react-toastify';
import { toastProperties } from '../../commons/Toast/Toaster';
import capacityGeneratorService from '../../components/Services/capacityGenerator.service';
import plantDetailsService from '../../components/Services/plantDetails.service';
import { GET_GEN_CAPACITY_ALL, GET_GEN_CAPACITY_EDIT_HISTORY, SET_PLANT_DETAILS } from './types';
import { enableButton } from '../ButtonFlag/actions';
import { useSelector } from 'react-redux';

export const createCapacityGenerator = ({ reqBody, handleSubmit,handleCapacityListing }) => async (dispatch) => {
    capacityGeneratorService.createGeneratorCapacity(reqBody)
        .then((response) => {
            if (response && response.data.code === 200) {
                !handleCapacityListing && getGeneratorCapacityall()(dispatch)
                toast.success(response?.data?.message, toastProperties)
                handleSubmit && handleSubmit('');
                enableButton()(dispatch);
                handleCapacityListing && handleCapacityListing('CapacityListing')
            }
            if (response && response.data.code !== 200) {
                enableButton()(dispatch);
            }
        }).catch((err) => {console.log(err);
        enableButton()(dispatch);})
}

export const updateCapacityGenerator = ( { reqBody, handleSubmit,handleCapacityListing } ) => async (dispatch) => {
    capacityGeneratorService.updateGeneratorCapacity(reqBody)
        .then((response) => {
            if (response && response.data.code === 200) {
                !handleCapacityListing && getGeneratorCapacityall()(dispatch)
                toast.success(response?.data?.message, toastProperties)
                handleSubmit && handleSubmit('');
                enableButton()(dispatch)
                handleCapacityListing && handleCapacityListing('CapacityListing');
            }
            if (response && response.data.code !== 200) {
                enableButton()(dispatch);
            }
        }).catch((err) => {console.log(err);
            enableButton()(dispatch);})
}

export const getGeneratorCapacityall = () => async (dispatch) => {
    capacityGeneratorService.getAllGeneratorCapacity()
        .then((response) => {
            if (response && response.data.code === 200) {
                dispatch({ type: GET_GEN_CAPACITY_ALL, payload: response?.data?.data });
                // toast.success(response?.data?.message,toastProperties)
            }
        }).catch(err => console.log(err))
}

export const getGeneratorPlantDetails = (data) => async (dispatch) => {
    let result = {}
    try {
        const response = await plantDetailsService.getPlantDetails(data);

        if (response.data.code === 200) {
            result.plantData = response.data.data
            dispatch({ type: SET_PLANT_DETAILS, payload: result });
            // toast.success(response.data.message, toastProperties);
        }
    } catch (error) {
        console.error('API call error:', error);
    }
};

export const getCapacityEditHistoryGenerator = (id,setIsLoading) => async (dispatch) => {
    setIsLoading(true)
    capacityGeneratorService.getCapacityEditHistoryGenerator(id)
        .then((response) => {
            if (response && response.data.code === 200) {
                dispatch({ type: GET_GEN_CAPACITY_EDIT_HISTORY, payload: response?.data?.data });
                // toast.success(response?.data?.message,toastProperties)
                setIsLoading(false)
            }
        }).catch(err => console.log(err)
        )
}